// 下载 excel 表中游戏类型列文案 map (目前应该只使用到 combine)
export const TypeMap: { [key: string]: string } = {
  combine: 'PC & Console',
  pc: 'PC',
  console: 'Console',
};
